export const enableScriptAudioPreload = true;
export const PRELOAD_SCRIPTS_CAP = 20;

export const assistantSize = {
  width: 192,
  height: 192,
};

export const bedrockResultNotFoundReply = "I don't know.";
export const bedrockResultNotFoundUserFriendlyReply =
  'No information available — please try a different question.';

// TODO: refactor as props
// the following flags are for debug purproses
export const enableDebugControls = false;
export const enableLogging = true;
// display mute button only on hover over assistant
export const showMuteButtonOnHover = false;
export const debugEventId = undefined;
export const debugTagName = undefined;
export const debugMapName = undefined;
